import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import { useTranslation } from "react-i18next";
import { CGI_BLACK, CGI_RED } from "../../helpers/enums";
import {
  Box,
  Divider,
  IconButton,
  Modal,
  Switch,
  Typography,
} from "@mui/material";

export default function EditModuleSettingsModal({
  updateShowHideModule,
  moduleData,
}) {
  const { t } = useTranslation();

  const [openSettings, setOpenSettings] = React.useState(false);

  return (
    <>
      <IconButton
        sx={{ mr: 5, color: CGI_BLACK }}
        onClick={() => setOpenSettings(true)}
      >
        <SettingsIcon />
      </IconButton>
      <Modal
        open={openSettings}
        onClose={() => setOpenSettings(false)}
        disableAutoFocus={true}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            borderRadius: 5,
            boxShadow: 24,
            maxHeight: "80vh",
            p: 4,
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  userSelect: "none",
                  fontSize: 18,
                  color: CGI_RED,
                  fontWeight: 500,
                }}
              >
                {t("configureShownModulesForEvaluation")}
              </Typography>
              <IconButton onClick={() => setOpenSettings(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider sx={{ my: 1, borderColor: CGI_RED }} />
            {moduleData.map((data, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderBottom: 1,
                  borderColor: "#ddd",
                  mb: 0.5,
                  pb: 0.5,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ width: 30, fontWeight: 500 }}>
                    {data.sortingNumber}.
                  </Typography>
                  <Typography>{data.name}</Typography>
                </Box>
                <Switch
                  checked={!data.hideModule}
                  sx={{ justifySelf: "flex-end", mr: 1 }}
                  onChange={() => updateShowHideModule(data.id)}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>
    </>
  );
}
